import useAppStore from '@/stores/app'

export const usePrice = () => {
  const appStore = useAppStore()

  const formatMoney = (amount: number | null = 0, to: string | null = null) => {
    if (!amount) {
      return '-'
    }

    if (!to) {
      to = appStore.currency.selected
    }

    let digits = 0

    if (to !== 'IDR') {
      digits = 2
    }

    const currencyRate = appStore.exchangeRates.find((rate) => rate.currency === to)

    const formatter = new Intl.NumberFormat(currencyRate?.locale, {
      minimumFractionDigits: digits,
      style: 'currency',
      currency: to
    })

    if (currencyRate) {
      return formatter.format(amount / currencyRate.rate)
    }

    return formatter.format(amount)
  }

  const getCurrencySymbol = () => {
    const currencyRate = appStore.exchangeRates.find(
      (rate) => rate.currency === appStore.currency.selected
    )

    return (0)
      .toLocaleString(currencyRate?.locale, {
        style: 'currency',
        currency: currencyRate?.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
      .replace(/\d/g, '')
      .trim()
  }

  return {
    formatMoney,
    getCurrencySymbol
  }
}
